import React from 'react';
import './kovin.css';

const AzrinEsmadyAriffin = () => {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          

        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">International</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/azrin.png" alt="Prof. Azrin E. Ariffin" />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3>Prof. Azrin Esmady Ariffin</h3>
              <div className="name-underline"></div>
            </div>
          </div>

          <div className="bio-container">
            <p className="bio">
                Prof. Azrin Esmady Ariffin is a distinguished figure in the Malaysian optometry landscape, 
                with over four decades of contributions to education, research, and professional development. 
            <br />
            
          A graduate of the University of New South Wales, Australia, Prof. Azrin also obtained a postgraduate 
          certificate in ocular drug use before earning his PhD from City University London. His academic journey saw 
          him serve as Head of Department at UKM before pioneering Malaysia’s first private undergraduate optometry 
          program in 2004 at a university college in Kuala Lumpur. Prof. Azrin further contributed to the field at 
          SEGi University, holding key leadership roles, including Vice-Chancellor. Since his retirement in 2023, 
          he has remained actively involved in advancing the profession as the President of the College of 
          Optometrists (Malaysia). His extensive expertise and leadership continue to shape the future of optometry in Malaysia. 

          <br />
          Prof Azrin currently is back in academia, post his official retirement as Deputy Vice Chancellor 
          (Academic) at University of Cyberjaya.

            </p>
            <div className="bio-decoration"></div>
          </div>
        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
           <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>
          <p className="register-cta">Register Now <span>&rarr;</span><a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};

export default AzrinEsmadyAriffin;